import { Skeleton, Typography } from '@mui/material';

import { LoadingOverlay } from 'shared/components/ui';
import { CommunityProductFragment, CommunitySubscriptionFragment } from 'shared/graphql';

import { CommunityProductPurchaseListItem } from '../CommunityProductPurchaseListItem';
import { Container } from './CommunityProductPurchaseList.styles';

interface Props {
  /**
   * The products to display.
   */
  products: Array<CommunityProductFragment | CommunitySubscriptionFragment> | undefined;

  /**
   * The number of skeletons to display.
   * @default 2
   */
  skeletonCount?: number;

  /**
   * Whether the products are loading.
   */
  isLoading: boolean;
}

export function CommunityProductPurchaseList({
  products = [],
  skeletonCount = 2,
  isLoading,
}: Props) {
  if (!isLoading && products.length === 0) {
    return (
      <Typography color="textSecondary" align="center">
        No products available
      </Typography>
    );
  }

  return (
    <Container>
      <LoadingOverlay
        loading={isLoading}
        overlay={Array.from({ length: skeletonCount }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" width="100%" height="4rem" />
        ))}
      >
        {products.map(product => (
          <CommunityProductPurchaseListItem key={product.id} product={product} />
        ))}
      </LoadingOverlay>
    </Container>
  );
}
